/* ==========================================================================
   UE Reviews Carousel
   ========================================================================== */

(function () {
  'use strict';

  function toNumber(value, fallback) {
    var number = Number(value);
    return Number.isFinite(number) ? number : fallback;
  }

  function toBoolean(value) {
    return value === 'true';
  }

  function initializeCarousel(carousel) {
    if (typeof window.Swiper === 'undefined') {
      console.warn('UE Reviews: Swiper is not loaded.');
      return;
    }

    if (carousel.ueReviewsSwiper) {
      carousel.ueReviewsSwiper.destroy(true, true);
    }

    var sectionId = carousel.dataset.sectionId;
    var previousButton = document.querySelector('[data-ue-reviews-prev="' + sectionId + '"]');
    var nextButton = document.querySelector('[data-ue-reviews-next="' + sectionId + '"]');
    var options = {
      slidesPerView: toNumber(carousel.dataset.slidesMobile, 1.1),
      spaceBetween: toNumber(carousel.dataset.gapMobile, 16),
      loop: toBoolean(carousel.dataset.loop),
      speed: toNumber(carousel.dataset.speed, 500),
      grabCursor: toBoolean(carousel.dataset.grabCursor),
      centeredSlides: toBoolean(carousel.dataset.centeredSlides),
      breakpoints: {
        750: {
          slidesPerView: toNumber(carousel.dataset.slidesTablet, 2),
          spaceBetween: toNumber(carousel.dataset.gapTablet, 20)
        },
        990: {
          slidesPerView: toNumber(carousel.dataset.slidesDesktop, 4),
          spaceBetween: toNumber(carousel.dataset.gapDesktop, 24)
        }
      }
    };

    if (previousButton && nextButton) {
      options.navigation = { prevEl: previousButton, nextEl: nextButton };
    }

    carousel.ueReviewsSwiper = new window.Swiper(carousel, options);
  }

  function initializeWithin(root) {
    var scope = root || document;
    var carousels = scope.matches && scope.matches('[data-ue-reviews-carousel]')
      ? [scope]
      : scope.querySelectorAll('[data-ue-reviews-carousel]');
    carousels.forEach(initializeCarousel);
  }

  function destroyWithin(root) {
    root.querySelectorAll('[data-ue-reviews-carousel]').forEach(function (carousel) {
      if (carousel.ueReviewsSwiper) {
        carousel.ueReviewsSwiper.destroy(true, true);
        carousel.ueReviewsSwiper = null;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeWithin(document); });
  } else {
    initializeWithin(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeWithin(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyWithin(event.target);
  });
})();

/* ==========================================================================
   UE Articles
   ========================================================================== */

(function () {
  'use strict';

  var rootSelector = '[data-ue-articles]';

  function getRoots(scope) {
    var searchRoot = scope || document;
    var roots = searchRoot.matches && searchRoot.matches(rootSelector)
      ? [searchRoot]
      : Array.from(searchRoot.querySelectorAll(rootSelector));

    return roots;
  }

  function getReturnedRoot(documentFragment, sectionId) {
    return Array.from(documentFragment.querySelectorAll(rootSelector)).find(function (root) {
      return root.dataset.sectionId === sectionId;
    });
  }

  function setButtonLoading(button, isLoading) {
    var label = button.querySelector('[data-ue-articles-load-label]');
    var defaultLabel = button.dataset.defaultLabel || (label ? label.textContent.trim() : '');

    button.disabled = isLoading;
    button.setAttribute('aria-busy', isLoading ? 'true' : 'false');

    if (label) {
      label.textContent = isLoading
        ? button.dataset.loadingLabel || defaultLabel
        : defaultLabel;
    }
  }

  function updateButton(root) {
    var state = root.ueArticlesState;
    var button = root.querySelector('[data-ue-articles-load-more]');
    var wrapper = root.querySelector('[data-ue-articles-load-wrap]');

    if (!button || !state) {
      return;
    }

    if (state.source === 'manual') {
      if (!root.querySelector('[data-ue-manual-card][hidden]') && wrapper) {
        wrapper.hidden = true;
      }
      return;
    }

    if (state.nextUrl) {
      button.dataset.nextUrl = state.nextUrl;
    } else {
      button.removeAttribute('data-next-url');
    }

    if (!state.nextUrl && state.buffer.length === 0 && wrapper) {
      wrapper.hidden = true;
    }
  }

  function revealManualCards(root) {
    var state = root.ueArticlesState;
    var hiddenCards = Array.from(root.querySelectorAll('[data-ue-manual-card][hidden]'));

    hiddenCards.slice(0, state.perLoad).forEach(function (card) {
      card.hidden = false;
      card.classList.remove('ue-articles-card--hidden');
    });

    updateButton(root);
  }

  function collectUniqueCards(cards, renderedIds, queuedIds) {
    return cards.filter(function (card) {
      var articleId = card.dataset.articleId;

      if (!articleId || renderedIds.has(articleId) || queuedIds.has(articleId)) {
        return false;
      }

      queuedIds.add(articleId);
      return true;
    });
  }

  function fetchNextCards(root, nextUrl, signal) {
    var sectionId = root.dataset.sectionId;
    var requestUrl = new URL(nextUrl, window.location.origin);

    requestUrl.searchParams.set('section_id', sectionId);

    return fetch(requestUrl.toString(), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      signal: signal
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('HTTP ' + response.status);
        }

        return response.text();
      })
      .then(function (html) {
        var documentFragment = new DOMParser().parseFromString(html, 'text/html');
        var returnedRoot = getReturnedRoot(documentFragment, sectionId);
        var returnedGrid = returnedRoot && returnedRoot.querySelector('[data-ue-articles-grid]');
        var returnedButton = returnedRoot && returnedRoot.querySelector('[data-ue-articles-load-more]');

        if (!returnedRoot || !returnedGrid) {
          throw new Error('Returned UE Articles grid was not found.');
        }

        return {
          cards: Array.from(returnedGrid.querySelectorAll('[data-ue-article-card]')),
          nextUrl: returnedButton ? returnedButton.dataset.nextUrl || null : null,
          requestUrl: requestUrl.toString()
        };
      });
  }

  function loadBlogCards(root, button) {
    var state = root.ueArticlesState;

    if (!state || state.loading || (!state.nextUrl && state.buffer.length === 0)) {
      return;
    }

    state.loading = true;
    state.abortController = new AbortController();
    setButtonLoading(button, true);

    var workingBuffer = state.buffer.slice();
    var workingNextUrl = state.nextUrl;
    var gathered = [];
    var queuedIds = new Set(workingBuffer.map(function (card) { return card.dataset.articleId; }));
    var requestedUrls = new Set();

    function fillBatch() {
      while (gathered.length < state.perLoad && workingBuffer.length > 0) {
        gathered.push(workingBuffer.shift());
      }

      if (gathered.length >= state.perLoad || !workingNextUrl) {
        return Promise.resolve();
      }

      var comparableUrl = new URL(workingNextUrl, window.location.origin).toString();
      if (requestedUrls.has(comparableUrl)) {
        workingNextUrl = null;
        return Promise.resolve();
      }
      requestedUrls.add(comparableUrl);

      return fetchNextCards(root, workingNextUrl, state.abortController.signal)
        .then(function (result) {
          var uniqueCards = collectUniqueCards(result.cards, state.renderedIds, queuedIds);

          workingNextUrl = result.nextUrl;
          workingBuffer = workingBuffer.concat(uniqueCards);
          return fillBatch();
        });
    }

    fillBatch()
      .then(function () {
        var grid = root.querySelector('[data-ue-articles-grid]');

        if (!grid) {
          throw new Error('Live UE Articles grid was not found.');
        }

        gathered.forEach(function (card) {
          state.renderedIds.add(card.dataset.articleId);
          grid.appendChild(card);
        });

        state.buffer = workingBuffer;
        state.nextUrl = workingNextUrl;
        updateButton(root);
      })
      .catch(function (error) {
        if (error.name !== 'AbortError') {
          console.error('UE Articles: Load More failed.', error);
        }
      })
      .finally(function () {
        state.loading = false;
        state.abortController = null;
        if (document.contains(button)) {
          setButtonLoading(button, false);
        }
      });
  }

  function initializeRoot(root) {
    if (!root || root.ueArticlesState) {
      return;
    }

    var button = root.querySelector('[data-ue-articles-load-more]');
    var cards = Array.from(root.querySelectorAll('[data-ue-article-card]:not([hidden])'));
    var source = root.dataset.source;

    root.ueArticlesState = {
      source: source,
      perLoad: Math.max(1, Number(root.dataset.articlesPerLoad) || 1),
      renderedIds: new Set(cards.map(function (card) { return card.dataset.articleId; }).filter(Boolean)),
      buffer: [],
      nextUrl: button ? button.dataset.nextUrl || null : null,
      loading: false,
      abortController: null
    };

    if (button) {
      button.addEventListener('click', function () {
        if (source === 'manual') {
          revealManualCards(root);
        } else {
          loadBlogCards(root, button);
        }
      });
      updateButton(root);
    }
  }

  function initializeWithin(scope) {
    getRoots(scope).forEach(initializeRoot);
  }

  function destroyWithin(scope) {
    getRoots(scope).forEach(function (root) {
      if (root.ueArticlesState && root.ueArticlesState.abortController) {
        root.ueArticlesState.abortController.abort();
      }
      root.ueArticlesState = null;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeWithin(document);
    });
  } else {
    initializeWithin(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeWithin(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyWithin(event.target);
  });
})();

/* ==========================================================================
   UE Header Mega Menu
   ========================================================================== */

(function () {
  'use strict';

  var megaSelector = '[data-ue-header-mega]';
  var desktopQuery = window.matchMedia('(min-width: 990px)');
  var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  var positionFrame = null;

  function getMegas() {
    return Array.from(document.querySelectorAll(megaSelector));
  }

  function getDuration(mega) {
    var wrapper = mega.closest('.ue-header-wrapper--enabled') || mega;
    var value = getComputedStyle(wrapper).getPropertyValue('--ue-header-mega-animation-duration').trim();
    var duration = parseFloat(value);

    if (!Number.isFinite(duration)) {
      return 300;
    }

    return value.endsWith('s') && !value.endsWith('ms') ? duration * 1000 : duration;
  }

  function clearMegaTimer(mega) {
    window.clearTimeout(mega.ueMegaTimer);
    mega.ueMegaTimer = null;
  }

  function setHeaderSectionLayer(mega, active) {
    var wrapper = mega && mega.closest('.ue-header-wrapper');
    var sectionHeader = wrapper && wrapper.closest('.section-header');

    if (sectionHeader) {
      sectionHeader.classList.toggle('ue-header-section-layer', active);
    }
  }

  function updateMegaPosition(mega) {
    var wrapper = mega && mega.closest('.ue-header-wrapper');
    var header = wrapper
      ? wrapper.querySelector('.ue-header')
      : mega && mega.closest('.ue-header');
    var positionSource = wrapper || header;
    var top = positionSource
      ? Math.max(0, Math.round(positionSource.getBoundingClientRect().bottom))
      : 80;

    if (wrapper) {
      wrapper.style.setProperty('--ue-header-mega-top', top + 'px');
    } else {
      document.documentElement.style.setProperty('--ue-header-mega-top', top + 'px');
    }
  }

  function updateAllOpenMegaPositions() {
    getMegas().forEach(function (mega) {
      if (mega.open) {
        updateMegaPosition(mega);
      }
    });
  }

  function hasOpenMega() {
    return desktopQuery.matches && getMegas().some(function (mega) {
      return mega.open;
    });
  }

  function scheduleOpenMegaPositionUpdate() {
    if (!hasOpenMega() || positionFrame !== null) {
      return;
    }

    positionFrame = window.requestAnimationFrame(function () {
      updateAllOpenMegaPositions();
      positionFrame = null;
    });
  }

  function finishClose(mega) {
    var summary = mega.querySelector('[data-ue-header-mega-summary]');

    clearMegaTimer(mega);
    mega.open = false;
    mega.classList.remove('is-opening', 'is-open', 'is-closing');
    setHeaderSectionLayer(mega, false);

    if (summary) {
      summary.setAttribute('aria-expanded', 'false');
    }
  }

  function closeMega(mega, immediate) {
    if (!mega || (!mega.open && !mega.classList.contains('is-opening'))) {
      return;
    }

    clearMegaTimer(mega);

    if (immediate || reducedMotionQuery.matches) {
      finishClose(mega);
      return;
    }

    mega.classList.remove('is-opening', 'is-open');
    mega.classList.add('is-closing');
    mega.ueMegaTimer = window.setTimeout(function () {
      finishClose(mega);
    }, getDuration(mega));
  }

  function closeOtherMegas(currentMega) {
    getMegas().forEach(function (mega) {
      if (mega !== currentMega && mega.open) {
        closeMega(mega, true);
      }
    });
  }

  function openMega(mega) {
    var summary = mega.querySelector('[data-ue-header-mega-summary]');

    clearMegaTimer(mega);
    closeOtherMegas(mega);
    updateMegaPosition(mega);
    setHeaderSectionLayer(mega, true);
    mega.classList.remove('is-closing', 'is-open');
    mega.open = true;
    mega.classList.add('is-opening');

    if (summary) {
      summary.setAttribute('aria-expanded', 'true');
    }

    if (reducedMotionQuery.matches) {
      mega.classList.remove('is-opening');
      mega.classList.add('is-open');
      return;
    }

    mega.getBoundingClientRect();
    window.requestAnimationFrame(function () {
      if (!mega.open || mega.classList.contains('is-closing')) {
        return;
      }

      mega.classList.add('is-open');
      mega.ueMegaTimer = window.setTimeout(function () {
        mega.classList.remove('is-opening');
        mega.ueMegaTimer = null;
      }, getDuration(mega));
    });
  }

  function initializeMega(mega) {
    var summary;

    if (!mega || mega.dataset.ueMegaInitialized === 'true') {
      return;
    }

    summary = mega.querySelector('[data-ue-header-mega-summary]');
    if (!summary) {
      return;
    }

    mega.dataset.ueMegaInitialized = 'true';

    summary.addEventListener('click', function (event) {
      if (!desktopQuery.matches) {
        return;
      }

      event.preventDefault();

      if (mega.open && !mega.classList.contains('is-closing')) {
        closeMega(mega, false);
      } else {
        openMega(mega);
      }
    });

    mega.addEventListener('focusout', function (event) {
      if (desktopQuery.matches && mega.open) {
        event.stopImmediatePropagation();
      }
    }, true);

    mega.addEventListener('toggle', function () {
      if (!desktopQuery.matches) {
        return;
      }

      if (!mega.open) {
        clearMegaTimer(mega);
        mega.classList.remove('is-opening', 'is-open', 'is-closing');
        setHeaderSectionLayer(mega, false);
      }
    });
  }

  function initializeWithin(scope) {
    var root = scope || document;
    var megas = root.matches && root.matches(megaSelector)
      ? [root]
      : root.querySelectorAll(megaSelector);

    megas.forEach(initializeMega);
  }

  function closeAll(immediate) {
    getMegas().forEach(function (mega) {
      closeMega(mega, immediate);
    });
  }

  document.addEventListener('click', function (event) {
    if (!desktopQuery.matches || event.target.closest(megaSelector)) {
      return;
    }

    if (getMegas().some(function (mega) { return mega.open; })) {
      if (!event.target.closest('.ue-header-wrapper')) {
        event.preventDefault();
      }
      closeAll(false);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || !desktopQuery.matches) {
      return;
    }

    var openMegaElement = getMegas().find(function (mega) { return mega.open; });
    if (openMegaElement) {
      var summary = openMegaElement.querySelector('[data-ue-header-mega-summary]');
      closeMega(openMegaElement, false);
      if (summary) {
        summary.focus();
      }
    }
  });

  desktopQuery.addEventListener('change', function (event) {
    if (!event.matches) {
      closeAll(true);
    } else {
      updateAllOpenMegaPositions();
    }
  });

  window.addEventListener('scroll', scheduleOpenMegaPositionUpdate, { passive: true });
  window.addEventListener('resize', scheduleOpenMegaPositionUpdate);

  document.addEventListener('shopify:section:load', function (event) {
    initializeWithin(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeWithin(document);
    });
  } else {
    initializeWithin(document);
  }
})();

/* ==========================================================================
   UE PDP Accordion
   ========================================================================== */

(function () {
  'use strict';

  var accordionSelector = '[data-ue-pdp-accordion]';
  var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function getDuration(accordion) {
    var value = parseFloat(getComputedStyle(accordion).getPropertyValue('--ue-main-product-accordion-duration'));
    return Number.isFinite(value) ? value : 300;
  }

  function getCollapsedHeight(accordion) {
    var value = parseFloat(getComputedStyle(accordion).getPropertyValue('--ue-main-product-accordion-collapsed-height'));
    return Number.isFinite(value) ? value : 180;
  }

  function clearPanelTransition(accordion, panel) {
    window.clearTimeout(accordion.uePdpAccordionTimer);
    panel.ontransitionend = null;
  }

  function afterHeightTransition(accordion, panel, callback) {
    var complete = false;

    function finish() {
      if (complete) {
        return;
      }

      complete = true;
      clearPanelTransition(accordion, panel);
      callback();
    }

    panel.ontransitionend = function (event) {
      if (event.target === panel && event.propertyName === 'height') {
        finish();
      }
    };
    accordion.uePdpAccordionTimer = window.setTimeout(finish, getDuration(accordion) + 80);
  }

  function getPanelHeight(accordion) {
    var content = accordion.querySelector('[data-ue-pdp-accordion-content]');
    var button = accordion.querySelector('[data-ue-pdp-accordion-show-more]');
    var height = 0;

    if (!content) {
      return 0;
    }

    height += content.getBoundingClientRect().height;

    if (button && button.offsetParent !== null) {
      height += button.getBoundingClientRect().height;
      height += parseFloat(getComputedStyle(button).marginTop) || 0;
      height += parseFloat(getComputedStyle(button).marginBottom) || 0;
    }

    return Math.ceil(height);
  }

  function setPanelAuto(panel) {
    if (panel) {
      panel.style.height = 'auto';
    }
  }

  function updatePanelHeight(accordion) {
    var details = accordion.querySelector('.ue-main-product__accordion-details');
    var panel = accordion.querySelector('[data-ue-pdp-accordion-panel]');

    if (!details || !panel) {
      return 0;
    }

    if (!details.open) {
      panel.style.height = '0px';
      return 0;
    }

    var height = getPanelHeight(accordion);
    panel.style.height = height + 'px';
    return height;
  }

  function refreshShowMoreState(accordion) {
    var details = accordion.querySelector('.ue-main-product__accordion-details');
    var content = accordion.querySelector('[data-ue-pdp-accordion-content]');
    var button = accordion.querySelector('[data-ue-pdp-accordion-show-more]');

    if (!content || !button) {
      return;
    }

    var showMoreLabel = button.dataset.showMoreLabel || 'Show more';
    var showLessLabel = button.dataset.showLessLabel || 'Show less';
    var needsShowMore = content.scrollHeight > getCollapsedHeight(accordion) + 1;
    var isExpanded = Boolean(details && details.open && button.classList.contains('is-expanded'));

    button.classList.toggle('is-visible', needsShowMore);

    if (!needsShowMore) {
      button.classList.remove('is-expanded');
      button.setAttribute('aria-expanded', 'false');
      button.textContent = showMoreLabel;
      content.classList.remove('is-clamped');
      return;
    }

    if (isExpanded) {
      content.classList.remove('is-clamped');
      button.setAttribute('aria-expanded', 'true');
      button.textContent = showLessLabel;
    } else {
      button.classList.remove('is-expanded');
      content.classList.add('is-clamped');
      button.setAttribute('aria-expanded', 'false');
      button.textContent = showMoreLabel;
    }
  }

  function animateShowMore(content, button, expand) {
    var accordion = button.closest(accordionSelector);
    var details = accordion && accordion.querySelector('.ue-main-product__accordion-details');
    var panel = accordion && accordion.querySelector('[data-ue-pdp-accordion-panel]');

    if (!accordion || !details || !panel || !content) {
      return;
    }

    clearPanelTransition(accordion, panel);

    if (reducedMotionQuery.matches) {
      button.classList.toggle('is-expanded', expand);
      content.classList.toggle('is-clamped', !expand);
      button.setAttribute('aria-expanded', expand ? 'true' : 'false');
      button.textContent = expand
        ? (button.dataset.showLessLabel || 'Show less')
        : (button.dataset.showMoreLabel || 'Show more');
      refreshShowMoreState(accordion);
      updatePanelHeight(accordion);
      if (details.open) {
        setPanelAuto(panel);
      }
      return;
    }

    var startHeight = getPanelHeight(accordion);
    panel.style.height = startHeight + 'px';
    panel.getBoundingClientRect();

    if (expand) {
      content.classList.remove('is-clamped');
    } else {
      content.classList.add('is-clamped');
    }

    updatePanelHeight(accordion);

    afterHeightTransition(accordion, panel, function () {
      button.classList.toggle('is-expanded', expand);
      button.setAttribute('aria-expanded', expand ? 'true' : 'false');
      button.textContent = expand
        ? (button.dataset.showLessLabel || 'Show less')
        : (button.dataset.showMoreLabel || 'Show more');
      refreshShowMoreState(accordion);

      if (details.open) {
        setPanelAuto(panel);
      }
    });
  }

  function openAccordion(accordion, immediate) {
    var details = accordion.querySelector('.ue-main-product__accordion-details');
    var panel = accordion.querySelector('[data-ue-pdp-accordion-panel]');

    if (!details || !panel) {
      return;
    }

    clearPanelTransition(accordion, panel);
    details.classList.remove('is-closing');
    details.open = true;
    refreshShowMoreState(accordion);

    if (immediate || reducedMotionQuery.matches) {
      updatePanelHeight(accordion);
      setPanelAuto(panel);
      return;
    }

    panel.style.height = '0px';
    panel.getBoundingClientRect();
    updatePanelHeight(accordion);
    afterHeightTransition(accordion, panel, function () {
      setPanelAuto(panel);
    });
  }

  function closeAccordion(accordion, immediate) {
    var details = accordion.querySelector('.ue-main-product__accordion-details');
    var panel = accordion.querySelector('[data-ue-pdp-accordion-panel]');

    if (!details || !panel || !details.open) {
      return;
    }

    clearPanelTransition(accordion, panel);

    if (immediate || reducedMotionQuery.matches) {
      details.open = false;
      details.classList.remove('is-closing');
      panel.style.height = '0px';
      refreshShowMoreState(accordion);
      return;
    }

    details.classList.add('is-closing');
    panel.style.height = getPanelHeight(accordion) + 'px';
    panel.getBoundingClientRect();
    panel.style.height = '0px';
    afterHeightTransition(accordion, panel, function () {
      details.open = false;
      details.classList.remove('is-closing');
      refreshShowMoreState(accordion);
      panel.style.height = '0px';
    });
  }

  function closeSiblings(accordion) {
    if (!accordion.classList.contains('ue-main-product__accordion--close-siblings')) {
      return;
    }

    var productInfo = accordion.closest('product-info') || accordion.closest('.ue-main-product') || document;
    productInfo.querySelectorAll(accordionSelector).forEach(function (sibling) {
      if (sibling !== accordion) {
        closeAccordion(sibling, false);
      }
    });
  }

  function initializeAccordion(accordion) {
    if (!accordion || accordion.uePdpAccordionInitialized) {
      return;
    }

    var details = accordion.querySelector('.ue-main-product__accordion-details');
    var summary = accordion.querySelector('.ue-main-product__accordion-summary');
    var panel = accordion.querySelector('[data-ue-pdp-accordion-panel]');
    var showMoreButton = accordion.querySelector('[data-ue-pdp-accordion-show-more]');

    if (!details || !summary || !panel) {
      return;
    }

    accordion.uePdpAccordionInitialized = true;

    summary.addEventListener('click', function (event) {
      event.preventDefault();
      if (details.open && !details.classList.contains('is-closing')) {
        closeAccordion(accordion, false);
      } else {
        closeSiblings(accordion);
        openAccordion(accordion, false);
      }
    });

    if (showMoreButton) {
      showMoreButton.addEventListener('click', function () {
        animateShowMore(accordion.querySelector('[data-ue-pdp-accordion-content]'), showMoreButton, !showMoreButton.classList.contains('is-expanded'));
      });
    }

    refreshShowMoreState(accordion);

    if (details.open) {
      openAccordion(accordion, true);
    } else {
      panel.style.height = '0px';
    }
  }

  function initializeWithin(scope) {
    var root = scope || document;
    var accordions = root.matches && root.matches(accordionSelector)
      ? [root]
      : root.querySelectorAll(accordionSelector);

    accordions.forEach(initializeAccordion);
  }

  function refreshOpenAccordions() {
    document.querySelectorAll(accordionSelector).forEach(function (accordion) {
      var details = accordion.querySelector('.ue-main-product__accordion-details');
      var panel = accordion.querySelector('[data-ue-pdp-accordion-panel]');

      if (details && panel && details.open && !details.classList.contains('is-closing')) {
        refreshShowMoreState(accordion);
        setPanelAuto(panel);
      }
    });
  }

  var resizeFrame;
  window.addEventListener('resize', function () {
    window.cancelAnimationFrame(resizeFrame);
    resizeFrame = window.requestAnimationFrame(refreshOpenAccordions);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeWithin(document);
    });
  } else {
    initializeWithin(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeWithin(event.target);
  });
})();

/* ==========================================================================
   UE FAQ Accordion
   ========================================================================== */

(function () {
  function initializeFaq(root) {
    if (!root || root.ueFaqInitialized) {
      return;
    }

    root.ueFaqInitialized = true;

    if (root.dataset.accordionMode !== 'single_open') {
      return;
    }

    var items = Array.from(root.querySelectorAll('.ue-faq__item'));
    var firstOpenItem = items.find(function (item) { return item.open; });

    items.forEach(function (item) {
      if (item.open && firstOpenItem && item !== firstOpenItem) {
        item.open = false;
      }

      item.addEventListener('toggle', function () {
        if (!item.open) {
          return;
        }

        items.forEach(function (sibling) {
          if (sibling !== item) {
            sibling.open = false;
          }
        });
      });
    });
  }

  function initializeWithin(scope) {
    var root = scope || document;
    var sections = root.matches && root.matches('[data-ue-faq]')
      ? [root]
      : root.querySelectorAll('[data-ue-faq]');

    sections.forEach(initializeFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeWithin(document);
    });
  } else {
    initializeWithin(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeWithin(event.target);
  });
})();

/* ==========================================================================
   UE PDP Shipping Calculator
   ========================================================================== */

(function () {
  'use strict';

  var calculatorSelector = '[data-ue-pdp-shipping-calculator]';
  var cookieName = 'cart';

  function getCookie(name) {
    var value = '; ' + document.cookie;
    var parts = value.split('; ' + name + '=');

    if (parts.length === 2) {
      return parts.pop().split(';').shift();
    }

    return null;
  }

  function updateCookie(name, value) {
    var date = new Date();
    date.setTime(date.getTime() + 14 * 86400000);
    document.cookie = name + '=' + value + '; expires=' + date.toUTCString() + '; path=/';
  }

  function clearCookie(name) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
  }

  function getSelectedVariantId(calculator) {
    var scope = calculator.closest('product-info') || calculator.closest('[id^="shopify-section-"]') || document;
    var candidate = scope.querySelector('form[action*="/cart/add"] [name="id"]');

    if (candidate && candidate.value) {
      return candidate.value;
    }

    candidate = scope.querySelector('.product-variant-id');

    if (candidate && candidate.value) {
      return candidate.value;
    }

    candidate = scope.querySelector('[name="id"]');

    if (candidate && candidate.value) {
      return candidate.value;
    }

    return new URLSearchParams(window.location.search).get('variant');
  }

  function normalizeMoneyValue(value) {
    if (value === null || typeof value === 'undefined' || value === '') {
      return 0;
    }

    if (typeof value === 'number' && Number.isFinite(value)) {
      return Math.round(value * 100);
    }

    var stringValue = String(value).trim().replace(/,/g, '');

    if (stringValue === '') {
      return 0;
    }

    if (stringValue.indexOf('.') > -1) {
      return Math.round(parseFloat(stringValue) * 100);
    }

    var parsed = parseInt(stringValue, 10);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function formatMoneyFallback(cents, moneyFormat) {
    var amount = (cents / 100).toFixed(2);

    if (!moneyFormat) {
      return amount;
    }

    return moneyFormat.replace(/\{\{\s*(amount|amount_no_decimals|amount_with_comma_separator|amount_no_decimals_with_comma_separator)\s*\}\}/, function (match, token) {
      if (token === 'amount_no_decimals') {
        return String(Math.round(cents / 100));
      }

      if (token === 'amount_with_comma_separator') {
        return amount.replace('.', ',');
      }

      if (token === 'amount_no_decimals_with_comma_separator') {
        return String(Math.round(cents / 100)).replace('.', ',');
      }

      return amount;
    });
  }

  function formatMoney(value, moneyFormat) {
    var cents = normalizeMoneyValue(value);

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && moneyFormat) {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }

    return formatMoneyFallback(cents, moneyFormat);
  }

  function setLoadingState(calculator, button, textNode, loading) {
    var loadingLabel = calculator.dataset.loadingLabel || 'Calculating...';
    var submitLabel = calculator.dataset.submitLabel || 'Calculate Shipping Rates';

    calculator.classList.toggle('is-loading', loading);

    if (button) {
      button.disabled = loading;
    }

    if (textNode) {
      textNode.textContent = loading ? loadingLabel : submitLabel;
    }
  }

  function setResponseState(response, type, message) {
    if (!response) {
      return;
    }

    response.classList.remove('is-success', 'is-error');

    if (type) {
      response.classList.add(type);
    }

    response.textContent = message || '';
  }

  function buildRateUrl(country, province, zip) {
    var params = new URLSearchParams();
    params.set('shipping_address[country]', country || '');
    params.set('shipping_address[province]', province || '');
    params.set('shipping_address[zip]', zip || '');
    return '/cart/shipping_rates.json?' + params.toString();
  }

  function fetchJson(url, options) {
    return fetch(url, options).then(function (response) {
      if (!response.ok) {
        throw new Error('Request failed');
      }

      return response.json();
    });
  }

  function calculateShipping(calculator) {
    var countryField = calculator.querySelector('[data-ue-shipping-country]');
    var provinceField = calculator.querySelector('[data-ue-shipping-province]');
    var zipField = calculator.querySelector('[data-ue-shipping-zip]');
    var button = calculator.querySelector('[data-ue-shipping-submit]');
    var submitText = calculator.querySelector('[data-ue-shipping-submit-text]');
    var response = calculator.querySelector('[data-ue-shipping-response]');
    var moneyFormat = calculator.dataset.moneyFormat || '';
    var variantId = getSelectedVariantId(calculator);
    var zip = zipField ? zipField.value.trim() : '';
    var country = countryField ? countryField.value : 'Australia';
    var province = provinceField ? provinceField.value : '';
    var originalCartCookie = getCookie(cookieName);
    var restoreCookieValue = originalCartCookie || ('temp-cart-cookie___' + Date.now());
    var fakeCookieValue = 'fake-cart-cookie___' + Date.now();
    var cleanedUp = false;

    function finish() {
      if (cleanedUp) {
        return;
      }

      cleanedUp = true;
      updateCookie(cookieName, restoreCookieValue);
      setLoadingState(calculator, button, submitText, false);
    }

    if (!zip) {
      setResponseState(response, 'is-error', calculator.dataset.emptyPostcodeMessage || 'Please enter a post code.');
      return;
    }

    if (!variantId) {
      setResponseState(response, 'is-error', calculator.dataset.variantMissingMessage || 'Product variant could not be found.');
      return;
    }

    if (!button || !submitText || !response) {
      return;
    }

    setResponseState(response, '', '');
    setLoadingState(calculator, button, submitText, true);

    if (!originalCartCookie) {
      updateCookie(cookieName, restoreCookieValue);
    }

    updateCookie(cookieName, fakeCookieValue);

    fetchJson('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest'
      },
      body: JSON.stringify({
        id: parseInt(variantId, 10),
        quantity: 1
      })
    })
      .then(function () {
        return fetchJson(buildRateUrl(country, province, zip), {
          method: 'GET',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'xmlhttprequest'
          }
        });
      })
      .then(function (data) {
        var rates = data && data.shipping_rates ? data.shipping_rates : [];

        if (rates.length) {
          var rate = rates[0];
          var ratePrice = formatMoney(rate.price, moneyFormat);
          var prefix = calculator.dataset.successPrefix || 'Available rate:';
          setResponseState(response, 'is-success', prefix + ' ' + rate.name + ' - ' + ratePrice);
        } else {
          setResponseState(response, 'is-error', calculator.dataset.noRatesMessage || 'No shipping rates could be found for your address.');
        }

        finish();
      })
      .catch(function () {
        setResponseState(response, 'is-error', calculator.dataset.noRatesMessage || 'No shipping rates could be found for your address.');
        finish();
      });
  }

  function initializeCalculator(calculator) {
    if (!calculator || calculator.ueShippingCalculatorInitialized) {
      return;
    }

    var button = calculator.querySelector('[data-ue-shipping-submit]');

    if (!button) {
      return;
    }

    calculator.ueShippingCalculatorInitialized = true;

    button.addEventListener('click', function () {
      calculateShipping(calculator);
    });
  }

  function initializeWithin(scope) {
    var root = scope || document;
    var calculators = root.matches && root.matches(calculatorSelector)
      ? [root]
      : root.querySelectorAll(calculatorSelector);

    calculators.forEach(initializeCalculator);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeWithin(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeWithin(document);
    });
  } else {
    initializeWithin(document);
  }
})();

/* ==========================================================================
   UE Main Collection AJAX
   ========================================================================== */

(function () {
  'use strict';

  var priceDebounceDelay = 500;

  function cleanBrowserUrl(url) {
    var parsed = new URL(url, window.location.origin);
    parsed.searchParams.delete('section_id');
    return parsed.toString();
  }

  function buildSectionUrl(url, sectionId) {
    var parsed = new URL(cleanBrowserUrl(url));
    parsed.searchParams.set('section_id', sectionId);
    return parsed.toString();
  }

  function serializeForm(form) {
    var parameters = new URLSearchParams();

    new FormData(form).forEach(function (value, name) {
      if (String(value).trim() !== '') {
        parameters.append(name, value);
      }
    });

    return parameters;
  }

  function buildFormUrl(root, form) {
    var url = new URL(root.dataset.collectionUrl, window.location.origin);
    var parameters = serializeForm(form);
    var sortSelect = root.querySelector('[data-ue-sort-select]');

    if (sortSelect && sortSelect.value) {
      parameters.set('sort_by', sortSelect.value);
    }

    parameters.forEach(function (value, name) {
      url.searchParams.append(name, value);
    });

    return url.toString();
  }

  function unlockDrawerScroll() {
    if (!document.querySelector('[data-ue-filter-drawer].is-open')) {
      document.body.classList.remove('ue-main-collection-drawer-open');
    }
  }

  function closeDrawer(root, restoreFocus, immediate) {
    var drawer = root.querySelector('[data-ue-filter-drawer]');
    var trigger = root.ueMainCollectionDrawerTrigger;
    var panel = drawer && drawer.querySelector('.ue-main-collection__drawer-panel');
    var animationSpeed = Number(root.dataset.drawerAnimationSpeed) || 280;

    if (!drawer || drawer.hidden) {
      return;
    }

    window.clearTimeout(root.ueMainCollectionDrawerTimer);
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    root.querySelectorAll('[data-ue-filter-drawer-open]').forEach(function (button) {
      button.setAttribute('aria-expanded', 'false');
    });

    var closeFinished = false;

    function finishClose() {
      if (closeFinished) {
        return;
      }

      closeFinished = true;
      window.clearTimeout(root.ueMainCollectionDrawerTimer);
      drawer.hidden = true;
      unlockDrawerScroll();

      if (restoreFocus !== false && trigger && document.contains(trigger)) {
        trigger.focus();
      }
    }

    if (immediate) {
      finishClose();
      return;
    }

    if (panel) {
      panel.addEventListener('transitionend', finishClose, { once: true });
    }
    root.ueMainCollectionDrawerTimer = window.setTimeout(finishClose, animationSpeed + 80);
  }

  function openDrawer(root, trigger) {
    var drawer = root.querySelector('[data-ue-filter-drawer]');
    var panel = drawer && drawer.querySelector('[role="dialog"]');

    if (!drawer) {
      return;
    }

    root.ueMainCollectionDrawerTrigger = trigger;
    window.clearTimeout(root.ueMainCollectionDrawerTimer);
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ue-main-collection-drawer-open');
    trigger.setAttribute('aria-expanded', 'true');

    window.requestAnimationFrame(function () {
      drawer.classList.add('is-open');

      if (panel) {
        panel.focus();
      }
    });
  }

  function setLoading(root, isLoading) {
    root.classList.toggle('ue-main-collection--loading', isLoading);

    if (isLoading) {
      root.setAttribute('aria-busy', 'true');
    } else {
      root.removeAttribute('aria-busy');
    }
  }

  function setLoadMoreState(button, isLoading) {
    var label = button.querySelector('[data-ue-load-more-label]');

    if (!button.dataset.defaultLabel && label) {
      button.dataset.defaultLabel = label.textContent.trim();
    }

    button.disabled = isLoading;
    button.classList.toggle('is-loading', isLoading);
    button.setAttribute('aria-busy', isLoading ? 'true' : 'false');

    if (label) {
      label.textContent = isLoading
        ? button.dataset.loadingLabel || button.dataset.defaultLabel
        : button.dataset.defaultLabel;
    }
  }

  function loadMoreProducts(root, button) {
    var nextUrl = button.dataset.nextUrl;
    var sectionId = root.dataset.sectionId;
    var currentGrid = root.querySelector('.ue-main-collection__grid');

    if (!nextUrl || !currentGrid || button.disabled) {
      return;
    }

    if (root.ueMainCollectionLoadMoreAbortController) {
      root.ueMainCollectionLoadMoreAbortController.abort();
    }

    root.ueMainCollectionLoadMoreAbortController = new AbortController();
    setLoadMoreState(button, true);

    fetch(buildSectionUrl(nextUrl, sectionId), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      signal: root.ueMainCollectionLoadMoreAbortController.signal
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('HTTP ' + response.status);
        }

        return response.text();
      })
      .then(function (html) {
        var documentFragment = new DOMParser().parseFromString(html, 'text/html');
        var newRoot = documentFragment.querySelector('.ue-main-collection--' + CSS.escape(sectionId));
        var newGrid = newRoot && newRoot.querySelector('.ue-main-collection__grid');

        if (!newRoot || !newGrid) {
          throw new Error('Next UE Main Collection product grid was not found.');
        }

        Array.from(newGrid.children).forEach(function (productCard) {
          currentGrid.appendChild(productCard);
        });

        var newButton = newRoot.querySelector('[data-ue-load-more]');
        var currentWrapper = button.closest('[data-ue-load-more-wrapper]');

        if (!newButton) {
          if (currentWrapper) {
            currentWrapper.remove();
          }
          return;
        }

        button.dataset.nextUrl = newButton.dataset.nextUrl;
        button.dataset.loadingLabel = newButton.dataset.loadingLabel;
        button.dataset.defaultLabel = newButton.querySelector('[data-ue-load-more-label]').textContent.trim();
        setLoadMoreState(button, false);
      })
      .catch(function (error) {
        if (error.name === 'AbortError') {
          return;
        }

        console.warn('UE Main Collection: load more failed.', error);
        setLoadMoreState(button, false);
      });
  }

  function fetchAndReplace(root, requestedUrl, options) {
    var settings = options || {};
    var sectionId = root.dataset.sectionId;
    var browserUrl = cleanBrowserUrl(requestedUrl);
    var sectionUrl = buildSectionUrl(browserUrl, sectionId);

    if (root.ueMainCollectionAbortController) {
      root.ueMainCollectionAbortController.abort();
    }

    if (root.ueMainCollectionLoadMoreAbortController) {
      root.ueMainCollectionLoadMoreAbortController.abort();
    }

    root.ueMainCollectionAbortController = new AbortController();
    closeDrawer(root, false, true);
    setLoading(root, true);

    return fetch(sectionUrl, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      signal: root.ueMainCollectionAbortController.signal
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('HTTP ' + response.status);
        }

        return response.text();
      })
      .then(function (html) {
        var documentFragment = new DOMParser().parseFromString(html, 'text/html');
        var newRoot = documentFragment.querySelector('.ue-main-collection--' + CSS.escape(sectionId));

        if (!newRoot) {
          throw new Error('Updated UE Main Collection markup was not found.');
        }

        if (settings.updateHistory !== false) {
          window.history.pushState({}, '', browserUrl);
        }

        root.replaceWith(newRoot);
        initializeSection(newRoot);

        if (settings.scrollToGrid) {
          newRoot.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }

        return newRoot;
      })
      .catch(function (error) {
        if (error.name === 'AbortError') {
          return null;
        }

        console.warn('UE Main Collection: AJAX update failed.', error);
        window.location.href = browserUrl;
        return null;
      })
      .finally(function () {
        if (document.contains(root)) {
          setLoading(root, false);
        }
      });
  }

  function handleDesktopFormChange(root, event) {
    var form = event.currentTarget;

    if (event.target.matches('[data-ue-price-input]')) {
      return;
    }

    fetchAndReplace(root, buildFormUrl(root, form));
  }

  function handlePriceInput(root, event) {
    var form = event.currentTarget;

    if (!event.target.matches('[data-ue-price-input]')) {
      return;
    }

    window.clearTimeout(root.ueMainCollectionPriceTimer);
    root.ueMainCollectionPriceTimer = window.setTimeout(function () {
      fetchAndReplace(root, buildFormUrl(root, form));
    }, priceDebounceDelay);
  }

  function handleSortChange(root, sortSelect) {
    var url = new URL(window.location.href);
    url.searchParams.delete('page');

    if (sortSelect.value) {
      url.searchParams.set('sort_by', sortSelect.value);
    } else {
      url.searchParams.delete('sort_by');
    }

    fetchAndReplace(root, url.toString());
  }

  function handleRootClick(root, event) {
    var openButton = event.target.closest('[data-ue-filter-drawer-open]');
    var closeButton = event.target.closest('[data-ue-filter-drawer-close]');
    var applyButton = event.target.closest('[data-ue-apply-mobile-filters]');
    var removeLink = event.target.closest('[data-ue-filter-remove]');
    var clearLink = event.target.closest('[data-ue-clear-all]');
    var paginationLink = event.target.closest('[data-ue-pagination-link]');
    var loadMoreButton = event.target.closest('[data-ue-load-more]');

    if (openButton) {
      openDrawer(root, openButton);
      return;
    }

    if (closeButton) {
      closeDrawer(root, true);
      return;
    }

    if (applyButton) {
      var mobileForm = root.querySelector('[data-ue-filter-form="mobile"]');
      if (mobileForm) {
        fetchAndReplace(root, buildFormUrl(root, mobileForm));
      }
      return;
    }

    if (loadMoreButton) {
      event.preventDefault();
      loadMoreProducts(root, loadMoreButton);
      return;
    }

    if (removeLink || clearLink || paginationLink) {
      var link = removeLink || clearLink || paginationLink;
      event.preventDefault();
      fetchAndReplace(root, link.href, { scrollToGrid: Boolean(paginationLink) });
    }
  }

  function initializeSection(root) {
    if (!root || root.ueMainCollectionInitialized) {
      return;
    }

    root.ueMainCollectionInitialized = true;
    root.querySelectorAll('.ue-main-collection__pagination a').forEach(function (link) {
      link.setAttribute('data-ue-pagination-link', '');
    });
    root.addEventListener('click', function (event) {
      handleRootClick(root, event);
    });

    var desktopForm = root.querySelector('[data-ue-filter-form="desktop"]');
    if (desktopForm) {
      desktopForm.addEventListener('submit', function (event) {
        event.preventDefault();
        fetchAndReplace(root, buildFormUrl(root, desktopForm));
      });
      desktopForm.addEventListener('change', function (event) {
        handleDesktopFormChange(root, event);
      });
      desktopForm.addEventListener('input', function (event) {
        handlePriceInput(root, event);
      });
    }

    var sortSelect = root.querySelector('[data-ue-sort-select]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        handleSortChange(root, sortSelect);
      });
    }
  }

  function initializeWithin(scope) {
    var context = scope || document;
    var roots = context.matches && context.matches('[data-ue-main-collection]')
      ? [context]
      : context.querySelectorAll('[data-ue-main-collection]');

    roots.forEach(initializeSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeWithin(document);
    });
  } else {
    initializeWithin(document);
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') {
      return;
    }

    document.querySelectorAll('[data-ue-filter-drawer]:not([hidden])').forEach(function (drawer) {
      var root = drawer.closest('[data-ue-main-collection]');
      if (root) {
        closeDrawer(root, true);
      }
    });
  });

  window.addEventListener('popstate', function () {
    document.querySelectorAll('[data-ue-main-collection]').forEach(function (root) {
      fetchAndReplace(root, window.location.href, { updateHistory: false });
    });
  });

  document.addEventListener('shopify:section:load', function (event) {
    initializeWithin(event.target);
  });
})();

/* ==========================================================================
   UE Products Carousel
   ========================================================================== */

(function () {
  'use strict';

  function toNumber(value, fallback) {
    var number = Number(value);
    return Number.isFinite(number) ? number : fallback;
  }

  function toBoolean(value) {
    return value === 'true';
  }

  function initializeCarousel(carousel) {
    if (typeof window.Swiper === 'undefined') {
      console.warn('UE Products: Swiper is not loaded.');
      return;
    }

    if (carousel.ueProductsSwiper) {
      carousel.ueProductsSwiper.destroy(true, true);
    }

    var sectionId = carousel.dataset.sectionId;
    var previousButton = document.querySelector('[data-ue-products-prev="' + sectionId + '"]');
    var nextButton = document.querySelector('[data-ue-products-next="' + sectionId + '"]');
    var options = {
      slidesPerView: toNumber(carousel.dataset.slidesMobile, 1.2),
      spaceBetween: toNumber(carousel.dataset.gapMobile, 16),
      loop: toBoolean(carousel.dataset.loop),
      speed: toNumber(carousel.dataset.speed, 500),
      grabCursor: toBoolean(carousel.dataset.grabCursor),
      centeredSlides: toBoolean(carousel.dataset.centeredSlides),
      breakpoints: {
        750: { slidesPerView: toNumber(carousel.dataset.slidesTablet, 2.5), spaceBetween: toNumber(carousel.dataset.gapTablet, 20) },
        990: { slidesPerView: toNumber(carousel.dataset.slidesDesktop, 5), spaceBetween: toNumber(carousel.dataset.gapDesktop, 24) }
      }
    };

    if (previousButton && nextButton) {
      options.navigation = { prevEl: previousButton, nextEl: nextButton };
    }

    carousel.ueProductsSwiper = new window.Swiper(carousel, options);
  }

  function initializeWithin(root) {
    var scope = root || document;
    var carousels = scope.matches && scope.matches('[data-ue-products-carousel]')
      ? [scope]
      : scope.querySelectorAll('[data-ue-products-carousel]');
    carousels.forEach(initializeCarousel);
  }

  function destroyWithin(root) {
    root.querySelectorAll('[data-ue-products-carousel]').forEach(function (carousel) {
      if (carousel.ueProductsSwiper) {
        carousel.ueProductsSwiper.destroy(true, true);
        carousel.ueProductsSwiper = null;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeWithin(document); });
  } else {
    initializeWithin(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initializeWithin(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { destroyWithin(event.target); });
})();

/* ==========================================================================
   UE Collections Carousel
   ========================================================================== */

(function () {
  'use strict';

  function toNumber(value, fallback) {
    var number = Number(value);
    return Number.isFinite(number) ? number : fallback;
  }

  function toBoolean(value) {
    return value === 'true';
  }

  function initializeCarousel(carousel) {
    if (typeof window.Swiper === 'undefined') {
      console.warn('UE Collections: Swiper is not loaded.');
      return;
    }

    if (carousel.ueCollectionsSwiper) {
      carousel.ueCollectionsSwiper.destroy(true, true);
    }

    var sectionId = carousel.dataset.sectionId;
    var previousButton = document.querySelector('[data-ue-collections-prev="' + sectionId + '"]');
    var nextButton = document.querySelector('[data-ue-collections-next="' + sectionId + '"]');
    var options = {
      slidesPerView: toNumber(carousel.dataset.slidesMobile, 1.1),
      spaceBetween: toNumber(carousel.dataset.gapMobile, 16),
      loop: toBoolean(carousel.dataset.loop),
      speed: toNumber(carousel.dataset.speed, 500),
      grabCursor: toBoolean(carousel.dataset.grabCursor),
      centeredSlides: toBoolean(carousel.dataset.centeredSlides),
      breakpoints: {
        750: {
          slidesPerView: toNumber(carousel.dataset.slidesTablet, 2),
          spaceBetween: toNumber(carousel.dataset.gapTablet, 20)
        },
        990: {
          slidesPerView: toNumber(carousel.dataset.slidesDesktop, 4),
          spaceBetween: toNumber(carousel.dataset.gapDesktop, 24)
        }
      }
    };

    if (previousButton && nextButton) {
      options.navigation = { prevEl: previousButton, nextEl: nextButton };
    }

    carousel.ueCollectionsSwiper = new window.Swiper(carousel, options);
  }

  function initializeWithin(root) {
    var scope = root || document;
    var carousels = scope.matches && scope.matches('[data-ue-collections-carousel]')
      ? [scope]
      : scope.querySelectorAll('[data-ue-collections-carousel]');
    carousels.forEach(initializeCarousel);
  }

  function destroyWithin(root) {
    root.querySelectorAll('[data-ue-collections-carousel]').forEach(function (carousel) {
      if (carousel.ueCollectionsSwiper) {
        carousel.ueCollectionsSwiper.destroy(true, true);
        carousel.ueCollectionsSwiper = null;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeWithin(document); });
  } else {
    initializeWithin(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeWithin(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyWithin(event.target);
  });
})();
